import React from "react";
import ErrorMask from "./errorMask.jsx";
import LoadingMask from "./loadingMask.jsx";

export default function MessageMask(props) {
    if (props.error)
        return <ErrorMask {...props} />;
    else
        return <LoadingMask {...props} />;
}